// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ExternalSubscriptionCheckController = function ($scope, $http) {
    $scope.bearer = {};

    $scope.check = function () {
        $http({
            method: "POST",
            url: "api/v1/externalSubscriptions/check",
            data: $scope.bearer,
            cache: false
        }).then(function (response) {
            $scope.response = response.data;
        }, function () {
            $scope.response = null;
        });
    };
};
ExternalSubscriptionCheckController.$inject = ['$scope', '$http'];
